import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import vendorService from '../../services/vendorService';
import './Vendors.css';
import VendorStore from './VendorStore';
import { useNavigate } from 'react-router-dom';
import CommonModal from '../../services/CommonModal';
import { toast } from 'react-toastify';
import { FaFileExcel } from 'react-icons/fa';

const Vendors = () => {
  const [vendors, setVendors] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    page: 1,
    limit: 10,
    status: '',
    category: '',
    search: ''
  });
  const [pagination, setPagination] = useState({});
  const [selectedVendorId, setSelectedVendorId] = useState(null);
  const navigate = useNavigate();

  const setSelectedVendor = VendorStore(
    (state) => state.setSelectedVendor
  );

  const confirmDelete = () => {
    handleDelete(selectedVendorId);
    setShowDeleteModal(false);
    setSelectedVendorId(null);
  };

  // const goToContract = (v) => {
  //   console.log("data", v)
  //   setSelectedVendor(v);
  //   // navigate('/app/tasks/new');
  // };

  const goToContract = (v) => {
    // console.log("data", v)
    setSelectedVendor(v);
    navigate(`/app/vendors/${v.id}/contracts`);
  };


  const goToEditVendor = (v) => {
    console.log("data", v)
    setSelectedVendor(v);
    navigate(`/app/vendors/${v.id}/edit`);
  };


  useEffect(() => {
    fetchVendors();
    fetchStats();
  }, [filters]);

  const fetchVendors = async () => {
    try {
      setLoading(true);
      const data = await vendorService.getAllVendors(filters);
      setVendors(data.vendors || data.data || []);
      setPagination(data.pagination || {});
      setError(null);
    } catch (err) {
      setError('Failed to fetch vendors');
      setVendors([]); // Ensure vendors is always an array
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const data = await vendorService.getVendorStats();
      setStats(data);
    } catch (err) {
      console.error('Failed to fetch stats:', err);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value,
      page: 1
    }));
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchVendors();
  };

  const handlePageChange = (newPage) => {
    setFilters(prev => ({ ...prev, page: newPage }));
  };

  const handleDelete = async (id) => {
    try {
      await vendorService.deleteVendor(id);
      toast.success('Deleted Successfully!');

      fetchVendors();
      fetchStats();

    } catch (err) {
      toast.error('Failed to delete vendor');
      console.error(err);
    }

  };

  const getStatusBadgeClass = (status) => {
    const statusClasses = {
      'Pending': 'badge-warning',
      'Under Review': 'badge-info',
      'Approved': 'badge-success',
      'Active': 'badge-success',
      'Suspended': 'badge-danger',
      'Rejected': 'badge-danger',
      'Inactive': 'badge-secondary'
    };
    return statusClasses[status] || 'badge-secondary';
  };

  if (loading && vendors.length === 0) {
    return <div className="loading">Loading Clients...</div>;
  }

  const handleDownloadVendorList = () => {
    if (!vendors || vendors.length === 0) {
      toast.error('No clients to download');
      return;
    }

    const headers = [
      'Client Code', 'Company Name', 'Category', 'Email', 'Phone', 'Status', 'Rating'
    ];

    const escapeCsv = (value) => {
      if (value === null || value === undefined) return '';
      const str = String(value);
      if (str.includes(',') || str.includes('"') || str.includes('\n')) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    };

    const rows = vendors.map((vendor) => [
      vendor.vendor_code,
      vendor.company_name,
      vendor.category,
      vendor.email,
      vendor.phone || '',
      vendor.status,
      vendor.rating || ''
    ]);

    const csvContent = [headers, ...rows]
      .map((row) => row.map(escapeCsv).join(','))
      .join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `clients-${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    toast.success('Client list downloaded');
  };

  return (
    <div className="vendors-page">
      <div className="page-header">
        <h1>Client Management</h1>
        <div className="flex gap-2">
          <button
            onClick={handleDownloadVendorList}
            className="px-4 py-2 bg-white border border-green-600 text-green-600 rounded-lg flex items-center gap-2"
            title="Download client list"
          >
            <FaFileExcel /> Download
          </button>
          <Link to="/app/vendors/create" className="btn btn-primary">
            <i className="fas fa-plus"></i> Add New Client
          </Link>
        </div>
      </div>

      {/* Statistics Cards */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">
            <i className="fas fa-building" style={{ color: '#fff' }}></i>
          </div>
          <div className="stat-content">
            <h3>{stats.totalVendors || 0}</h3>
            <p>Total Clients</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon active">
            <i className="fas fa-check-circle"></i>
          </div>
          <div className="stat-content">
            <h3>{stats.activeVendors || 0}</h3>
            <p>Active Clients</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon pending">
            <i className="fas fa-clock"></i>
          </div>
          <div className="stat-content">
            <h3>{stats.pendingVendors || 0}</h3>
            <p>Pending Approval</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon contracts">
            <i className="fas fa-file-contract"></i>
          </div>
          <div className="stat-content">
            <h3>{stats.activeContracts || 0}</h3>
            <p>Active Contracts</p>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="filters-section">
        <form onSubmit={handleSearch} className="search-form">
          <input
            type="text"
            name="search"
            placeholder="Search clients..."
            value={filters.search}
            onChange={handleFilterChange}
            className="search-input"
          />
          <button type="submit" className="btn btn-secondary">
            <i className="fas fa-search"></i> Search
          </button>
        </form>

        <div className="filter-controls">
          <select
            name="status"
            value={filters.status}
            onChange={handleFilterChange}
            className="filter-select"
          >
            <option value="">All Status</option>
            <option value="Pending">Pending</option>
            <option value="Under Review">Under Review</option>
            <option value="Approved">Approved</option>
            <option value="Active">Active</option>
            <option value="Suspended">Suspended</option>
            <option value="Rejected">Rejected</option>
            <option value="Inactive">Inactive</option>
          </select>

          <select
            name="category"
            value={filters.category}
            onChange={handleFilterChange}
            className="filter-select"
          >
            <option value="">All Categories</option>
            <option value="IT Services">IT Services</option>
            <option value="Consulting">Consulting</option>
            <option value="Manufacturing">Manufacturing</option>
            <option value="Logistics">Logistics</option>
            <option value="Marketing">Marketing</option>
            <option value="HR Services">HR Services</option>
            <option value="Legal">Legal</option>
            <option value="Financial">Financial</option>
            <option value="Other">Other</option>
          </select>
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}

      {/* Vendors Table */}
      <div className="table-container">
        <table className="vendors-table">
          <thead>
            <tr>
              <th>Client Code</th>
              <th>Company Name</th>
              <th>Category</th>
              <th>Contact</th>
              <th>Status</th>
              <th>Create Contract</th>
              <th>Rating</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {vendors.length === 0 ? (
              <tr>
                <td colSpan="7" className="no-data">
                  No vendors found
                </td>
              </tr>
            ) : (
              vendors.map(vendor => (
                <tr key={vendor.id}>
                  <td>
                    <Link to={`/app/vendors/${vendor.id}`} className="vendor-code">
                      {vendor.vendor_code}
                    </Link>
                  </td>
                  <td>
                    <div className="vendor-name">
                      <strong>{vendor.company_name}</strong>
                      {vendor.vendor_type && (
                        <span className="vendor-type">{vendor.vendor_type}</span>
                      )}
                    </div>
                  </td>
                  <td>
                    <span className="category-badge">{vendor.category}</span>
                  </td>
                  <td>
                    <div className="contact-info">
                      <div>{vendor.email}</div>
                      {vendor.phone && <div className="phone">{vendor.phone}</div>}
                    </div>
                  </td>
                  <td>
                    <span className={`badge ${getStatusBadgeClass(vendor.status)}`}>
                      {vendor.status}
                    </span>
                  </td>

                  <td>

                    {/* <Link to={`/app/vendors/contracts`} className="vendor-code">
                        Add Contract
                      </Link> */}

                    <span

                      className="vendor-code cursor-pointer"
                      onClick={() => goToContract(vendor)}
                    >
                      Create Contract
                    </span>

                  </td>
                  <td>
                    {vendor.rating ? (
                      <div className="rating">
                        {'★'.repeat(vendor.rating)}
                        {'☆'.repeat(5 - vendor.rating)}
                      </div>
                    ) : (
                      <span className="no-rating">Not rated</span>
                    )}
                  </td>
                  <td>
                    <div className="action-buttons">
                      <Link
                        to={`/app/vendors/${vendor.id}`}
                        className="btn btn-sm btn-info"
                        title="View"
                      >
                        <i className="fas fa-eye"></i>
                      </Link>
                      {/* <Link
                        to={`/app/vendors/${vendor.id}/edit`}
                        className="btn btn-sm btn-warning"
                        title="Edit"
                      >
                        <i className="fas fa-edit"></i>
                      </Link> */}

                      <button
                        onClick={() => goToEditVendor(vendor)}
                        className="btn btn-sm btn-danger"
                        title="Delete"
                      >
                        <i className="fas fa-edit"></i>
                      </button>
                      <button
                        onClick={() => {
                          setSelectedVendorId(vendor.id);
                          setShowDeleteModal(true);
                        }}
                        className="btn btn-sm btn-danger"
                        title="Delete"
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <CommonModal
        isOpen={showDeleteModal}
        title="Delete Vendor"
        message="Are you sure you want to delete this vendor?"
        onClose={() => {
          setShowDeleteModal(false);
          setSelectedVendorId(null);
        }}
        onConfirm={confirmDelete}
        type="error"
        confirmText="Delete"
        cancelText="Cancel"
      />

      {/* Pagination */}
      {pagination.totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => handlePageChange(pagination.page - 1)}
            disabled={pagination.page === 1}
            className="btn btn-secondary"
          >
            Previous
          </button>
          <span className="page-info">
            Page {pagination.page} of {pagination.totalPages}
          </span>
          <button
            onClick={() => handlePageChange(pagination.page + 1)}
            disabled={pagination.page === pagination.totalPages}
            className="btn btn-secondary"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default Vendors;

